import Types from "./Types";

export const getAllStudentsRequest = (page, searchTerm, subjectId) => ({
  type: Types.GET_STUDENTS_REQUEST,
  payload: page,
  searchTerm: searchTerm,
  subjectId: subjectId,
});

export const getAllStudentsSuccess = (data) => ({
  type: Types.GET_STUDENTS_SUCCESS,
  payload: data,
});

export const getAllStudentsFail = () => ({
  type: Types.GET_STUDENTS_FAIL,
});

export const getAllStudentForCsvsRequest = (page, searchTerm) => ({
  type: Types.GET_STUDENTS_FOR_CSV_REQUEST,
  payload: page,
  searchTerm: searchTerm,
});

export const getAllStudentsForCsvSuccess = (data) => ({
  type: Types.GET_STUDENTS_FOR_CSV_SUCCESS,
  payload: data,
});

export const getAllStudentsForCsvFail = () => ({
  type: Types.GET_STUDENTS_FOR_CSV_FAIL,
});

export const getStudentsForBulkMessageRequest = (subject_id) => ({
  type: Types.GET_STUDENTS_FOR_BULK_MESSAGE_REQUEST,
  payload: subject_id,
});

export const getStudentsForBulkMessageSuccess = (data) => ({
  type: Types.GET_STUDENTS_FOR_BULK_MESSAGE_SUCCESS,
  payload: data,
});

export const getStudentsForBulkMessageFail = () => ({
  type: Types.GET_STUDENTS_FOR_BULK_MESSAGE_FAIL,
});

export const editStudentRequest = (formData, action) => ({
  type: Types.EDIT_STUDENT_REQUEST,
  payload: formData,
  action: action,
});

export const editStudentSuccess = (data) => ({
  type: Types.EDIT_STUDENT_SUCCESS,
  payload: data,
});

export const editStudentFail = () => ({
  type: Types.EDIT_STUDENT_FAIL,
});

//LOADING
export const addStudentLoading = (isLoading) => ({
  type: Types.ADD_STUDENTS_LOADING,
  payload: isLoading,
});

// Create Student
export const createStudentRequest = (formData, action) => ({
  type: Types.CREATE_STUDENT_REQUEST,
  payload: formData,
  action: action,
});

export const createStudentSuccess = ({ data }) => ({
  type: Types.CREATE_STUDENT_SUCCESS,
  payload: {
    data,
  },
});

export const createStudentFail = () => ({
  type: Types.CREATE_STUDENT_FAIL,
});

export const getStudentRequest = (id) => ({
  type: Types.GET_STUDENT_REQUEST,
  payload: id,
});

export const getStudentSuccess = (data) => ({
  type: Types.GET_STUDENT_SUCCESS,
  payload: data,
});

export const getStudentFail = () => ({
  type: Types.GET_STUDENT_FAIL,
});

export const deleteStudentRequest = (id, reason) => ({
  type: Types.DELETE_STUDENT_REQUEST,
  payload: id,
  reason: reason,
});

export const deleteStudentSuccess = (data) => ({
  type: Types.DELETE_STUDENT_SUCCESS,
  payload: data,
});

export const deleteStudentFail = () => ({
  type: Types.DELETE_STUDENT_FAIL,
});

export const getStudentReportRequest = (id) => ({
  type: Types.GET_STUDENT_REPORT_REQUEST,
  payload: id,
});

export const getStudentReportSuccess = (data) => ({
  type: Types.GET_STUDENT_REPORT_SUCCESS,
  payload: data,
});

export const getStudentReportFail = () => ({
  type: Types.GET_STUDENT_REPORT_FAIL,
});

export const restrictStudentRequest = (data) => ({
  type: Types.RESTRICT_STUDENT_REQUEST,
  payload: data,
});

export const restrictStudentSuccess = (data) => ({
  type: Types.RESTRICT_STUDENT_SUCCESS,
  payload: data,
});

export const restrictStudentFail = () => ({
  type: Types.RESTRICT_STUDENT_FAIL,
});

export const clearSessionRequest = (id) => ({
  type: Types.CLEAR_SESSION_REQUEST,
  payload: id,
});

export const clearSessionSuccess = (data) => ({
  type: Types.CLEAR_SESSION_SUCCESS,
  payload: data,
});

export const clearSessionFail = () => ({
  type: Types.CLEAR_SESSION_FAIL,
});

export const addBulkStudentRequest = (formData) => ({
  type: Types.ADD_BULK_STUDENT_REQUEST,
  payload: formData,
});

export const addBulkStudentSuccess = (id) => ({
  type: Types.ADD_BULK_STUDENT_SUCCESS,
  payload: id,
});

export const addBulkStudentFail = () => ({
  type: Types.ADD_BULK_STUDENT_FAIL,
});

export const exportBulkStudentRequest = (formData) => ({
  type: Types.EXPORT_BULK_STUDENT_REQUEST,
  payload: formData,
});

export const exportBulkStudentSuccess = (id) => ({
  type: Types.EXPORT_BULK_STUDENT_SUCCESS,
  payload: id,
});

export const exportBulkStudentFail = () => ({
  type: Types.EXPORT_BULK_STUDENT_FAIL,
});

//LOADING
export const suspendLoading = (isLoading) => ({
  type: Types.SUSPEND_LOADING,
  payload: isLoading,
});

//LOADING
export const restrictLoading = (isLoading) => ({
  type: Types.RESTRICT_LOADING,
  payload: isLoading,
});

export const approvedStudentsListRequest = (page, searchTerm, studentGroupId) => ({
  type: Types.STUDENT_APPROVED_LIST_REQUEST,
  payload: page,
  searchTerm: searchTerm,
  studentGroupId: studentGroupId,
});

export const approvedStudentsListSuccess = (payload) => ({
  type: Types.STUDENT_APPROVED_LIST_SUCCESS,
  payload,
});

export const studentsRequestsListRequest = (page, searchTerm) => ({
  type: Types.STUDENT_REQUESTS_LIST_REQUEST,
  payload: page,
  searchTerm: searchTerm,
});

export const studentsRequestsListSuccess = (payload) => ({
  type: Types.STUDENT_REQUESTS_LIST_SUCCESS,
  payload,
});

export const approveStudentRequest = (id) => ({
  type: Types.APPROVE_STUDENT_REQUEST,
  payload: id,
});

export const approveStudentSuccess = (payload) => ({
  type: Types.APPROVE_STUDENT_SUCCESS,
  payload,
});

export const rejectStudentRequest = (id) => ({
  type: Types.REJECT_STUDENT_REQUEST,
  payload: id,
});

export const rejectStudentSuccess = (payload) => ({
  type: Types.REJECT_STUDENT_SUCCESS,
  payload,
});

// Resend Password
export const resendPasswordRequest = (id) => ({
  type: Types.RESEND_PASSWORD_REQUEST,
  payload: id,
});

export const resendPasswordSuccess = (data) => ({
  type: Types.RESEND_PASSWORD_SUCCESS,
  payload: data,
});

export const resendPasswordFail = () => ({
  type: Types.RESEND_PASSWORD_FAIL,
});

// Send Credentials
export const sendCredentialsRequest = (id) => ({
  type: Types.SEND_CREDENTIALS_REQUEST,
  payload: id,
});

export const sendCredentialsSuccess = (data) => ({
  type: Types.SEND_CREDENTIALS_SUCCESS,
  payload: data,
});

export const sendCredentialsFail = () => ({
  type: Types.SEND_CREDENTIALS_FAIL,
});

// Get Inactive Students
export const getInactiveStudentsRequest = (page, searchTerm, flag) => ({
  type: Types.GET_INACTIVE_STUDENTS_REQUEST,
  payload: page,
  searchTerm: searchTerm,
  flag: flag,
});

export const getInactiveStudentsSuccess = (data) => ({
  type: Types.GET_INACTIVE_STUDENTS_SUCCESS,
  payload: data,
});

export const getInactiveStudentsFail = () => ({
  type: Types.GET_INACTIVE_STUDENTS_FAIL,
});